import { post } from './http-methods'

const login = form => post('/auth', form).then(resp => {
  if(resp.status === 200) {
    return { jwt: resp.json.data.jwt, user: resp.json.data.user };
  } else {
    return Promise.reject(resp);
  }
});

export default { login }
